import { Grid } from '@mui/material';
import {
  IniciadoAutorizadoAnualDemorasTotal,
  IniciadoAutorizadoAnualLineaTotal,
  IniciadoAutorizadoMensualLineaTotal,
} from '../components';

export const IniciadoAutorizadoTotalesSection = () => {
  return (
    <>
      {/*<IniciadoAutorizadoMensualLineaTotal />*/}
      <IniciadoAutorizadoAnualLineaTotal />
      <IniciadoAutorizadoAnualDemorasTotal />
    </>
  );
};
